import { z } from 'zod'
import { ErrorCode } from '~/types/error'
import { Role } from '~/types/user'

export const userRoleSchema = z.object({
  role: z.nativeEnum(Role, { errorMap: () => ({ message: ErrorCode.REQUIRED }) }),
})

export type UserRoleFormData = z.infer<typeof userRoleSchema>
